import { render, staticRenderFns } from "./ReturnCard.vue?vue&type=template&id=36bb4f1c&"
import script from "./ReturnCard.vue?vue&type=script&lang=js&"
export * from "./ReturnCard.vue?vue&type=script&lang=js&"
import style0 from "./ReturnCard.vue?vue&type=style&index=0&id=36bb4f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports